/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "دیروز",
        "-2": "پریروز",
        "0": "امروز",
        "1": "فردا",
        "2": "پس‌فردا",
        "future": {
          "one": "{0} روز دیگر",
          "other": "{0} روز دیگر"
        },
        "past": {
          "one": "{0} روز پیش",
          "other": "{0} روز پیش"
        }
      },
      "day-narrow": {
        "-1": "دیروز",
        "-2": "پریروز",
        "0": "امروز",
        "1": "فردا",
        "2": "پس‌فردا",
        "future": {
          "one": "{0} روز بعد",
          "other": "{0} روز بعد"
        },
        "past": {
          "one": "{0} روز پیش",
          "other": "{0} روز پیش"
        }
      },
      "day-short": {
        "-1": "دیروز",
        "-2": "پریروز",
        "0": "امروز",
        "1": "فردا",
        "2": "پس‌فردا",
        "future": {
          "one": "{0} روز دیگر",
          "other": "{0} روز دیگر"
        },
        "past": {
          "one": "{0} روز پیش",
          "other": "{0} روز پیش"
        }
      },
      "hour": {
        "0": "همین ساعت",
        "future": {
          "one": "{0} ساعت بعد",
          "other": "{0} ساعت بعد"
        },
        "past": {
          "one": "{0} ساعت پیش",
          "other": "{0} ساعت پیش"
        }
      },
      "hour-narrow": {
        "0": "همین ساعت",
        "future": {
          "one": "{0} ساعت بعد",
          "other": "{0} ساعت بعد"
        },
        "past": {
          "one": "{0} ساعت پیش",
          "other": "{0} ساعت پیش"
        }
      },
      "hour-short": {
        "0": "همین ساعت",
        "future": {
          "one": "{0} ساعت بعد",
          "other": "{0} ساعت بعد"
        },
        "past": {
          "one": "{0} ساعت پیش",
          "other": "{0} ساعت پیش"
        }
      },
      "minute": {
        "0": "همین دقیقه",
        "future": {
          "one": "{0} دقیقه بعد",
          "other": "{0} دقیقه بعد"
        },
        "past": {
          "one": "{0} دقیقه پیش",
          "other": "{0} دقیقه پیش"
        }
      },
      "minute-narrow": {
        "0": "همین دقیقه",
        "future": {
          "one": "{0} دقیقه بعد",
          "other": "{0} دقیقه بعد"
        },
        "past": {
          "one": "{0} دقیقه پیش",
          "other": "{0} دقیقه پیش"
        }
      },
      "minute-short": {
        "0": "همین دقیقه",
        "future": {
          "one": "{0} دقیقه بعد",
          "other": "{0} دقیقه بعد"
        },
        "past": {
          "one": "{0} دقیقه پیش",
          "other": "{0} دقیقه پیش"
        }
      },
      "month": {
        "-1": "ماه گذشته",
        "0": "این ماه",
        "1": "ماه آینده",
        "future": {
          "one": "{0} ماه بعد",
          "other": "{0} ماه بعد"
        },
        "past": {
          "one": "{0} ماه پیش",
          "other": "{0} ماه پیش"
        }
      },
      "month-narrow": {
        "-1": "ماه گذشته",
        "0": "این ماه",
        "1": "ماه آینده",
        "future": {
          "one": "{0} ماه بعد",
          "other": "{0} ماه بعد"
        },
        "past": {
          "one": "{0} ماه پیش",
          "other": "{0} ماه پیش"
        }
      },
      "month-short": {
        "-1": "ماه گذشته",
        "0": "این ماه",
        "1": "ماه آینده",
        "future": {
          "one": "{0} ماه بعد",
          "other": "{0} ماه بعد"
        },
        "past": {
          "one": "{0} ماه پیش",
          "other": "{0} ماه پیش"
        }
      },
      "nu": ["arabext"],
      "quarter": {
        "-1": "سه‌ماههٔ گذشته",
        "0": "سه‌ماههٔ کنونی",
        "1": "سه‌ماههٔ آینده",
        "future": {
          "one": "{0} سه‌ماههٔ بعد",
          "other": "{0} سه‌ماههٔ بعد"
        },
        "past": {
          "one": "{0} سه‌ماههٔ پیش",
          "other": "{0} سه‌ماههٔ پیش"
        }
      },
      "quarter-narrow": {
        "-1": "سه‌ماههٔ گذشته",
        "0": "سه‌ماههٔ کنونی",
        "1": "سه‌ماههٔ آینده",
        "future": {
          "one": "{0} سه‌ماههٔ بعد",
          "other": "{0} سه‌ماههٔ بعد"
        },
        "past": {
          "one": "{0} سه‌ماههٔ پیش",
          "other": "{0} سه‌ماههٔ پیش"
        }
      },
      "quarter-short": {
        "-1": "سه‌ماههٔ گذشته",
        "0": "سه‌ماههٔ کنونی",
        "1": "سه‌ماههٔ آینده",
        "future": {
          "one": "{0} سه‌ماههٔ بعد",
          "other": "{0} سه‌ماههٔ بعد"
        },
        "past": {
          "one": "{0} سه‌ماههٔ پیش",
          "other": "{0} سه‌ماههٔ پیش"
        }
      },
      "second": {
        "0": "اکنون",
        "future": {
          "one": "{0} ثانیه بعد",
          "other": "{0} ثانیه بعد"
        },
        "past": {
          "one": "{0} ثانیه پیش",
          "other": "{0} ثانیه پیش"
        }
      },
      "second-narrow": {
        "0": "اکنون",
        "future": {
          "one": "{0} ثانیه بعد",
          "other": "{0} ثانیه بعد"
        },
        "past": {
          "one": "{0} ثانیه پیش",
          "other": "{0} ثانیه پیش"
        }
      },
      "second-short": {
        "0": "اکنون",
        "future": {
          "one": "{0} ثانیه بعد",
          "other": "{0} ثانیه بعد"
        },
        "past": {
          "one": "{0} ثانیه پیش",
          "other": "{0} ثانیه پیش"
        }
      },
      "week": {
        "-1": "هفتهٔ گذشته",
        "0": "این هفته",
        "1": "هفتهٔ آینده",
        "future": {
          "one": "{0} هفته بعد",
          "other": "{0} هفته بعد"
        },
        "past": {
          "one": "{0} هفته پیش",
          "other": "{0} هفته پیش"
        }
      },
      "week-narrow": {
        "-1": "هفتهٔ گذشته",
        "0": "این هفته",
        "1": "هفتهٔ آینده",
        "future": {
          "one": "{0} هفته بعد",
          "other": "{0} هفته بعد"
        },
        "past": {
          "one": "{0} هفته پیش",
          "other": "{0} هفته پیش"
        }
      },
      "week-short": {
        "-1": "هفتهٔ گذشته",
        "0": "این هفته",
        "1": "هفتهٔ آینده",
        "future": {
          "one": "{0} هفته بعد",
          "other": "{0} هفته بعد"
        },
        "past": {
          "one": "{0} هفته پیش",
          "other": "{0} هفته پیش"
        }
      },
      "year": {
        "-1": "سال گذشته",
        "0": "امسال",
        "1": "سال آینده",
        "future": {
          "one": "{0} سال بعد",
          "other": "{0} سال بعد"
        },
        "past": {
          "one": "{0} سال پیش",
          "other": "{0} سال پیش"
        }
      },
      "year-narrow": {
        "-1": "سال گذشته",
        "0": "امسال",
        "1": "سال آینده",
        "future": {
          "one": "{0} سال بعد",
          "other": "{0} سال بعد"
        },
        "past": {
          "one": "{0} سال پیش",
          "other": "{0} سال پیش"
        }
      },
      "year-short": {
        "-1": "سال گذشته",
        "0": "امسال",
        "1": "سال آینده",
        "future": {
          "one": "{0} سال بعد",
          "other": "{0} سال بعد"
        },
        "past": {
          "one": "{0} سال پیش",
          "other": "{0} سال پیش"
        }
      }
    },
    "locale": "fa"
  });
}